import ImportStatusModel from '@models/map/ImportStatusModel';
import ImportTypeModel   from '@models/map/ImportTypeModel';
import ProjectModel      from '@models/map/ProjectModel';
import doc               from '@widesk-core/decorators/doc';
import model             from '@widesk-core/decorators/model';
import MapServiceModel   from '@/models/MapServiceModel';
import TimestampAble     from '@widesk-core/models/traits/TimestampAble';
import Blamable          from '@/models/traits/Blamable';

@model.urnResource('import')
@doc.path('/imports/{?id}')
export default class ImportModel extends Blamable(TimestampAble(MapServiceModel)) {
	private declare _tsFilters: {
		'createdAt[after]': string | Date | Dayjs;
		'createdAt[before]': string | Date | Dayjs;
		'createdAt[strictly_after]': string | Date | Dayjs;
		'createdAt[strictly_before]': string | Date | Dayjs;
		'importStatus': id;
		'importStatus.reference': Map_ImportStatusReference;
		'importType': id;
		'importType.reference': Map_ImportTypeReference;
		'project': id;
		'updatedAt[after]': string | Date | Dayjs;
		'updatedAt[before]': string | Date | Dayjs;
		'updatedAt[strictly_after]': string | Date | Dayjs;
		'updatedAt[strictly_before]': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'updatedAt': string;
	};

	@doc.model(ImportStatusModel) declare importStatus: ImportStatusModel;
	@doc.model(ImportTypeModel) declare importType: ImportTypeModel;
	@doc.number declare nbDuplicates: number;
	@doc.number declare nbInsertions: number;
	@doc.number declare nbLocked: number;
	@doc.number declare nbUpdates: number;
	@doc.model(ProjectModel) declare project: ProjectModel;
	@doc.string declare updates: string;
}